import { FC, ReactNode } from 'react';
import { Dropdown, Menu } from 'antd';
import { TbCalendarShare } from 'react-icons/tb';

import { AppIcon } from '@/assets';
import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { DropdownMenuPanel } from '@/shared/components/dropdowns/DropdownPanel';

interface PublicPageContextMenuProps {
    aboutUrl?: string;
    children: ReactNode;
    includeDemo?: boolean;
}

const PublicPageContextMenu: FC<PublicPageContextMenuProps> = ({
    aboutUrl = 'https://countercyclical.io/about',
    children,
    includeDemo = false,
}) => {
    const { token } = useAntDesignTheme();

    return (
        <Dropdown
            trigger={['contextMenu']}
            popupRender={() => (
                <DropdownMenuPanel style={{ width: 16 * 16 }}>
                    <div style={{ marginBottom: '0.25rem' }}>
                        <small style={{ padding: '0 0.75rem', color: token.colorTextTertiary }}>Help Menu</small>
                    </div>
                    <Menu.Item
                        key='whatIsCountercyclical'
                        icon={
                            <img
                                alt='Countercyclical'
                                src={AppIcon}
                                height='20rem'
                                width='20rem'
                                style={{
                                    verticalAlign: '-0.3rem',
                                    marginRight: '0.375rem',
                                    marginLeft: '-0.175rem',
                                }}
                            />
                        }
                        onClick={() => {
                            window.open(aboutUrl, '_blank', 'noopener,noreferrer');
                        }}
                    >
                        What is Countercyclical?
                    </Menu.Item>
                    {includeDemo && (
                        <Menu.Item
                            key='demo'
                            icon={<TbCalendarShare size='1rem' />}
                            onClick={() => {
                                window.open('https://cal.com/countercyclical/demo', '_blank', 'noopener,noreferrer');
                            }}
                        >
                            Schedule a Demo
                        </Menu.Item>
                    )}
                </DropdownMenuPanel>
            )}
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: '100%',
                    minWidth: 0,
                    width: '100%',
                }}
            >
                {children}
            </div>
        </Dropdown>
    );
};

export default PublicPageContextMenu;
